import { Cloudinary } from 'cloudinary-core';
const asyncImportScript = (src, defer = true) => {
  const scriptBlock = document.createElement('script');
  scriptBlock.src = src;
  if (defer) {
    scriptBlock.defer = true;
  } else {
    scriptBlock.async = true;
  }
  document.head.appendChild(scriptBlock);
  return scriptBlock;
};
const cloudinaryCss = 'https://vjs.zencdn.net/7.10.2/video-js.min.css';
const cloudinaryJs = 'https://vjs.zencdn.net/7.10.2/video.min.js';
const VIDEOSELECTOR = 'video-js';
const VIDEOCLOUDINARYSELECTOR = 'video-js--cloudinary';
const VIDEOYOUTUBESELECTOR = 'video-js--youtube';
const cldOpt = {
  cdn_subdomain: true,
  private_cdn: true,
  cloud_name: 'leroymerlin',
  secure: true
};
const cldVideoOptions = {
  resource_type: 'video',
  preload: 'auto',
  streaming_profile: 'hd/DAMEO',
  source_types: ['m3u8', 'mpd'],
  source_transformation: {
    'm3u8': [{
      streaming_profile: 'sp_hd',
      format: 'm3u8'
    }],
    'mpd': [{
      streaming_profile: 'sp_hd',
      format: 'mpd'
    }]
  }
};
const videoFormats = [{
  name: 'HLS',
  type: 'application/x-mpegurl',
  format: 'm3u8'
}, {
  name: 'DASH',
  type: 'application/dash+xml',
  format: 'mpd'
}];
class Video {
  constructor() {
    this.prmVideos = document.querySelectorAll(`.${VIDEOSELECTOR}`);
    showVideos.call(this);
    initYoutubeVideo.call(this);
  }
  pauseVideos() {
    // check if brightcove already init video (videos lazyloaded with intersectionObserver)
    if (typeof videojs !== 'undefined') {
      const players = videojs.getAllPlayers();
      for (let i = 0; i < players.length; i++) {
        players[i].pause();
      }
    }
  }
}
function initYoutubeVideo() {
  const createEmbeded = videoContainer => {
    const {
      videoId,
      width,
      height
    } = videoContainer.dataset;
    const frame = document.createElement('iframe');
    frame.classList.add('ka-video__frame');
    frame.width = parseInt(width, 10) || videoContainer.offsetWidth;
    frame.height = parseInt(height, 10) || videoContainer.offsetHeight;
    frame.src = `https://www.youtube.com/embed/${videoId}?showinfo=0&rel=0&autoplay=1`;
    frame.title = 'YouTube video player';
    frame.setAttribute('frameborder', '0');
    frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    frame.setAttribute('allowfullscreen', 'true');
    videoContainer.innerHTML = '';
    videoContainer.appendChild(frame);
  };
  document.querySelectorAll(`.${VIDEOYOUTUBESELECTOR}`).forEach(videoContainer => {
    videoContainer.addEventListener('playVideo', () => {
      createEmbeded(videoContainer);
    });
    videoContainer.querySelector('.js-start-video-btn').addEventListener('click', () => {
      createEmbeded(videoContainer);
    });
  });
}
function showVideos() {
  this.observer = new IntersectionObserver(_lazyLoadVideo.bind(this), {
    root: null,
    rootMargin: '0px',
    threshold: 0
  });
  for (let i = 0; i < this.prmVideos.length; i++) {
    this.observer.observe(this.prmVideos[i]);
  }
}
function concatSources(url) {
  let sources = '';
  for (const type of videoFormats) {
    sources += `<source src=${url}.${type.format} type=${type.type} />`;
  }
  return sources;
}
function checkLinks(url) {
  const linkTags = document.getElementsByTagName('link');
  for (let i = linkTags.length; i--;) {
    if (linkTags[i].href === url) return true;
  }
  return false;
}
function checkScripts(url) {
  const scriptTags = document.getElementsByTagName('script');
  for (let i = scriptTags.length; i--;) {
    if (scriptTags[i].src === url) return true;
  }
  return false;
}
function _lazyLoadVideo(prmEntries) {
  // loop on all observers videos
  for (let i = 0; i < prmEntries.length; i++) {
    // check if video is visible in viewport
    if (prmEntries[i].isIntersecting) {
      if (prmEntries[i].target.classList.contains(VIDEOCLOUDINARYSELECTOR)) {
        if (!checkLinks(cloudinaryCss)) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.href = cloudinaryCss;
          link.media = 'all';
          document.head.appendChild(link);
        }
        if (!checkScripts(cloudinaryJs)) {
          asyncImportScript(cloudinaryJs);
        }
        const cdlPlayers = document.querySelectorAll(`.${VIDEOCLOUDINARYSELECTOR}`);
        for (let i = 0; i < cdlPlayers.length; i++) {
          const videoId = cdlPlayers[i].dataset.id;
          const cld = new Cloudinary(cldOpt);
          const videoUrl = cld.url(videoId, cldVideoOptions);
          const sources = concatSources(videoUrl);
          cdlPlayers[i].insertAdjacentHTML('afterbegin', sources);
        }
      } else {
        asyncImportScript(`//players.brightcove.net/${prmEntries[i].target.getAttribute('data-account')}/${prmEntries[i].target.getAttribute('data-player')}_default/index.min.js`);
      }
      this.observer.unobserve(prmEntries[i].target);
    }
  }
}
export default Video;